import React from 'react';
import {
    Table,
    TableColumn,
    TableRow,
    TableHeaderTheme,
    TableRowTheme,
    TableBorderRadius,
    TableBorderStyle,
    TableRowSeperatorStyle,
} from '@apply/components';

export const TableDemo: React.FC = () => {
    const htmlElement = () => {
        return (
            <div>
                <b>Editor</b>
            </div>
        );
    };

    const tableData: TableRow[] = [
        {
            Name: 'Alice Johnson',
            Email: 'alice@example.com',
            Role: 'Administrator',
        },
        {
            Name: 'Bob Smith',
            Email: 'bob@example.com',
            Role: 'User',
        },
        {
            Name: 'Charlie Lee',
            Email: 'charlie@example.com',
            Role: htmlElement(),
        },
    ];

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h3>Tables: </h3>
            <br />
            <br />
            <b>Table with Header</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>Table with no Header</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                data={tableData}
                width='100%'
                showHeader={false}
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='30%'
                />
            </Table>
            <br />
            <br />
            <b>
                <u>Row Font Size Specified (12px example)</u>
            </b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
                rowFontSize='12px'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>
                <u>Seperator Examples</u>
            </b>
            <br />
            <br />
            <b>None</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
                rowSeperatorStyle={TableRowSeperatorStyle.None}
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>Small</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
                rowSeperatorStyle={TableRowSeperatorStyle.Small}
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>Medium</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
                rowSeperatorStyle={TableRowSeperatorStyle.Medium}
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>Large</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
                rowSeperatorStyle={TableRowSeperatorStyle.Large}
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>
                <u>Style Examples</u>
            </b>
            <br />
            <br />
            <b>All White</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.White}
                rowTheme={TableRowTheme.White}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>All Gray</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.Gray}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>All Red</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Red}
                rowTheme={TableRowTheme.Red}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>All Blue</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Blue}
                rowTheme={TableRowTheme.Blue}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>All Yellow</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Yellow}
                rowTheme={TableRowTheme.Yellow}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>All Transparent</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Transparent}
                rowTheme={TableRowTheme.Transparent}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>Blue</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Blue}
                rowTheme={TableRowTheme.White}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>Red</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Red}
                rowTheme={TableRowTheme.White}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>Gray</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.White}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
            <br />
            <br />
            <b>Yellow</b>
            <br />
            <br />
            <Table
                headerTheme={TableHeaderTheme.Yellow}
                rowTheme={TableRowTheme.White}
                borderRadius={TableBorderRadius.Small}
                borderStyle={TableBorderStyle.Solid}
                data={tableData}
                width='100%'
            >
                <TableColumn
                    columnKey='Name'
                    header='Name'
                    width='30%'
                />
                <TableColumn
                    columnKey='Email'
                    header='Email'
                    width='40%'
                />
                <TableColumn
                    columnKey='Role'
                    header='Role'
                    width='20%'
                />
            </Table>
        </div>
    );
};
